import React, { FC, MouseEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { fc } from 'i18n';
import { TepIntents } from 'constants/tep';
import Input from 'core/react/general/form/Input';
import { Tooltip } from 'components/atoms/tooltip';
import { ITepEntryPass, ITepLease } from 'types/tep';
import { leasesCellSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IEmailProps {
  entryPass: ITepEntryPass;
}

export const EmailCell: FC<IEmailProps> = ({ entryPass }) => {
  const { id, intent } = useSelector(leasesCellSelector);

  const { control, formState } = useFormContext<Partial<ITepLease>>();

  const error = formState.errors.email?.message;

  const isEdit = intent === TepIntents.InlineEdit && entryPass.id === id;

  const tooltip = entryPass.lease?.email ? `${entryPass.lease?.email} (click to copy)` : '';

  const stopPropagation = (event: MouseEvent) => event.stopPropagation();

  const copyEmailToBuffer = async (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (entryPass.lease?.email) {
      await navigator.clipboard.writeText(entryPass.lease.email);
    }
  };

  return isEdit ? (
    <Controller
      control={control}
      name="email"
      rules={{ required: fc('please enter email') }}
      render={({ value, onChange }) => (
        <div className={styles.input} onClick={stopPropagation}>
          <Input placeholder="enter email address" value={value} onChange={onChange} />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div className={styles.email} onClick={copyEmailToBuffer}>
      <Tooltip isNoTranslate text={tooltip}>
        <div className={styles.ellipsisBox}>
          <span className={styles.emailText}>{entryPass.lease?.email || '-'}</span>
        </div>
      </Tooltip>
    </div>
  );
};
